import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: theme.spacing(2),
    overflow: 'auto',

    '& > .content': {
      display: 'grid',
      gridRow: 'auto',
      gridGap: theme.spacing(2),

      '&.grid': {
        gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))',

        [theme.breakpoints.only('sm')]: {
          gridTemplateColumns: 'repeat(auto-fill,minmax(200px,1fr))',
        },
        [theme.breakpoints.down('xs')]: {
          gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))',
        },
      },
      '&.list': {
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'minmax(min-content, max-content)',
      },
    },
  },
  contextBarActions: {
    display: 'flex',
    alignItems: 'center',

    '& .view-mode-toggle': {
      margin: theme.spacing(0, 1),
    },
  },
}));

export default styles;
